<app-breadcrumb
  [master]="'Administracja'"
  [parentName]="'Chronie - Komunikaty techniczne'"
  [name]="isEdit ? 'Edytuj' : 'Dodaj'">
</app-breadcrumb>

<div class="maintenance-window-form-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="save()"
      [class.spinner]="processingRequest"
      [disabled]="processingRequest || loading"
      mat-stroked-button
      color="primary">
      <mat-icon>save</mat-icon>
      <span>Zapisz</span>
    </button>

    <button
      (click)="clear()"
      [disabled]="processingRequest || loading"
      mat-stroked-button>
      <mat-icon>clear_all</mat-icon>
      <span>Wyczyść</span>
    </button>

    <button (click)="cancel()" [disabled]="processingRequest" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span>Anuluj</span>
    </button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <form [formGroup]="form" fxFlex="50" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            <h3>Konfiguracja komunikatu</h3>
            <div class="section-description">Ustaw okres widoczności, tytuł i treść banera.</div>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <mat-checkbox [formControl]="enabledControl">Konfiguracja aktywna</mat-checkbox>
            <mat-checkbox [formControl]="noticeEnabledControl">Wyświetlaj baner</mat-checkbox>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="row" fxLayoutGap="15px" fxFlex="50">
            <div fxFlex>
              <app-datepicker
                label="Wyświetlaj od"
                placeholder="2000-01-01"
                [required]="true"
                [minDate]="minDisplayFromDate"
                [control]="displayFromControl">
              </app-datepicker>
            </div>
            <div
              class="time-control"
              [class.backend-error]="displayFromTimeControl.hasError('backendConflict')"
              fxFlex="175px">
              <ngx-timepicker-field
                [format]="24"
                [defaultTime]="'08:00'"
                [formControl]="displayFromTimeControl">
              </ngx-timepicker-field>
            </div>
          </div>


          <div fxLayout="row" fxLayoutGap="15px" fxFlex="50">
            <div fxFlex>
              <app-datepicker
                label="Wyświetlaj do"
                placeholder="2000-01-01"
                [required]="true"
                [minDate]="minDisplayToDate"
                [control]="displayToControl">
              </app-datepicker>
            </div>
            <div
              class="time-control"
              [class.backend-error]="displayToTimeControl.hasError('backendConflict')"
              fxFlex="175px">
              <ngx-timepicker-field
                [format]="24"
                [defaultTime]="'23:30'"
                [formControl]="displayToTimeControl">
              </ngx-timepicker-field>
            </div>
          </div>

          <app-alert *ngIf="backendAlertMessage"
            [message]="backendAlertMessage"
            type="error">
          </app-alert>
        </div>

        <mat-form-field>
          <mat-label>Tytuł komunikatu</mat-label>
          <input matInput [formControl]="titleControl" maxlength="255">
          <mat-error *ngIf="titleControl.hasError('required')">Tytuł jest wymagany</mat-error>
          <mat-error *ngIf="titleControl.hasError('backendError')">{{ titleControl.getError('backendError') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Treść wiadomości</mat-label>
          <textarea matInput rows="5" [formControl]="messageControl"></textarea>
          <mat-hint>Możesz używać zmiennych z tabeli obok. Backend podstawi wartości w publicznym komunikacie.
          </mat-hint>
          <mat-error *ngIf="messageControl.hasError('required')">Treść jest wymagana</mat-error>
          <mat-error *ngIf="messageControl.hasError('backendError')">{{ messageControl.getError('backendError') }}
          </mat-error>
        </mat-form-field>
      </mat-card>

      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div>
          <h3>Czas wdrożenia i blokada sprzedaży</h3>
          <div class="section-description">Określ czas prac i towarzystwo, którego sprzedaż ma być czasowo
            zablokowana.
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="15px">
          <div fxLayout="row" fxLayoutGap="15px" fxFlex="50">
            <div fxFlex>
              <app-datepicker
                label="Data rozpoczęcia"
                placeholder="2000-01-01"
                [required]="true"
                [minDate]="minStartsAtDate"
                [maxDate]="maxStartsAtDate"
                [control]="startsAtControl">
              </app-datepicker>
            </div>
            <div class="time-control" fxFlex="175px">
              <ngx-timepicker-field
                [format]="24"
                [defaultTime]="'22:30'"
                [formControl]="startsAtTimeControl">
              </ngx-timepicker-field>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxFlex="50">
            <div fxFlex>
              <app-datepicker
                label="Data zakończenia"
                placeholder="2000-01-01"
                [required]="true"
                [minDate]="minEndsAtDate"
                [maxDate]="maxEndsAtDate"
                [control]="endsAtControl">
              </app-datepicker>
            </div>
            <div class="time-control" fxFlex="175px">
              <ngx-timepicker-field
                [format]="24"
                [defaultTime]="'23:30'"
                [formControl]="endsAtTimeControl">
              </ngx-timepicker-field>
            </div>
          </div>
        </div>

        <div *ngIf="form.touched && (form.hasError('invalidMaintenanceRange') || form.hasError('maintenanceBeforeBanner') || form.hasError('maintenanceAfterBanner'))"
             class="mat-error" role="alert" style="color: #f44336; font-size: 12px;">
          <div *ngIf="form.hasError('invalidMaintenanceRange')">Zakończenie wdrożenia musi być późniejsze niż rozpoczęcie.</div>
          <div *ngIf="form.hasError('maintenanceBeforeBanner')">Wdrożenie nie może rozpoczynać się przed wyświetlaniem banera.</div>
          <div *ngIf="form.hasError('maintenanceAfterBanner')">Wdrożenie musi zakończyć się najpóźniej z końcem wyświetlania banera.</div>
        </div>

        <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="start center">
          <mat-checkbox [formControl]="blockPurchasesControl">Blokuj zakup podczas wdrożenia</mat-checkbox>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="100">
            <mat-label>Towarzystwo ubezpieczeniowe</mat-label>
            <mat-select [formControl]="insuranceCompanyIdControl">
              <mat-option [value]="0">Wszystkie towarzystwa</mat-option>
              <mat-option *ngFor="let company of insuranceCompanies" [value]="company.id">
                {{ company.name }}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="!blockPurchasesControl.value">
              Wybór towarzystwa ogranicza komunikat do danego TU. Brak wyboru oznacza komunikat globalny.
            </mat-hint>
            <mat-hint *ngIf="blockPurchasesControl.value && insuranceCompanyIdControl.value">
              W czasie wdrożenia zablokowana będzie sprzedaż wszystkich produktów wybranego TU.
            </mat-hint>
            <mat-hint *ngIf="blockPurchasesControl.value && !insuranceCompanyIdControl.value">
              W czasie wdrożenia zablokowana będzie sprzedaż wszystkich produktów wszystkich TU.
            </mat-hint>
          </mat-form-field>
        </div>
      </mat-card>


    </form>
    <div fxFlex="50" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div><h3>Zmienne dostępne w treści komunikatu</h3>
        </div>
        <div class="variables-table-container">
          <table mat-table [dataSource]="variables" class="variables-table">

            <ng-container matColumnDef="variable">
              <th mat-header-cell *matHeaderCellDef>Zmienna</th>
              <td mat-cell *matCellDef="let item">
                <button
                  type="button"
                  mat-button
                  color="primary"
                  class="variable-button"
                  (click)="copyVariable(item.variable)">
                  {{ item.variable }}
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Zastosowanie</th>
              <td mat-cell *matCellDef="let item">
                {{ item.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="example">
              <th mat-header-cell *matHeaderCellDef>Przykład</th>
              <td mat-cell *matCellDef="let item">
                {{ item.example }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="variablesDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: variablesDisplayedColumns;"></tr>
          </table>
        </div>
      </mat-card>
    </div>
  </div>
</div>
